import { AgxService, useGetPoisonQueueMessages } from '@urbanx/agx.support.client';
import {
  AgxButton,
  AgxColumn,
  AgxRow,
  AgxTable,
  AgxTextInput,
  AgxTypography,
  IColumnConfig,
  Icon_Arrow,
} from '@urbanx/agx.ui-components2';
import Panel from 'components/panel/Panel';
import { useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import SupportBackButton from '../SupportBackButton';
import { messageRows } from './messageRows';
import { filterMessages, messageFilterLabels, MessageFilters } from './messageFilters';

const tableColumns: (string | IColumnConfig)[] = ['Id', 'Inserted At', { name: 'Message Body' }];

const PoisonQueue = () => {
  const [filters, setFilters] = useState<MessageFilters>({
    campaignId: '',
    contractId: '',
    eventType: '',
    userId: '',
  });
  const { service, queueName } = useParams<{
    service: AgxService;
    queueName: string;
  }>();

  const { data: queueMessages, isPending: isQueueMessagesPending } = useGetPoisonQueueMessages(
    service!,
    queueName!,
    !!service && !!queueName
  );

  const filteredMessages = filterMessages(queueMessages ?? [], filters);

  const rows = useMemo(() => {
    return messageRows(filteredMessages);
  }, [filteredMessages]);

  return (
    <AgxColumn gap="spacing-xl" fill>
      <SupportBackButton />
      <Panel
        title={
          <AgxRow gap="spacing-sm" alignItems="alignCenter">
            <AgxButton
              id={'backToPoisonQueuesButton'}
              text={''}
              variant={'naked'}
              leftIcon={<Icon_Arrow direction={'left'} />}
              renderLink={(props) => <Link to="../" {...props} />}
              ariaLabel="Back to poison queues"
            />
            <AgxTypography id="poison-queue-title" type="title" size="large">
              Messages in Poison Queue - {service} - {queueName}
            </AgxTypography>
          </AgxRow>
        }
      >
        <AgxRow gap="spacing-sm" wrap>
          {Object.entries(messageFilterLabels)
            .filter(([key]) => key !== 'eventType')
            .map(([key, label]) => (
              <AgxTextInput
                key={key}
                id={`poison-queue-filter-${key}`}
                type="text"
                label={label}
                hideOptionalText
                onChange={(value) => setFilters((previous) => ({ ...previous, [key]: value }))}
              />
            ))}
        </AgxRow>
        <AgxTable
          columns={tableColumns}
          rows={rows}
          renderRowLink={(index, linkProps) => {
            const message = filteredMessages[index];
            if (!message?.id) return;
            return <Link {...linkProps} to={`./${message.id}`} aria-label={message.id} />;
          }}
          showLoadingState={isQueueMessagesPending}
          noDataLabel={
            queueMessages?.length
              ? 'No loaded messages match these filters'
              : 'Poison Queue is currently empty'
          }
        />
      </Panel>
    </AgxColumn>
  );
};

export default PoisonQueue;
